<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3" style="display:inline;clear:none;">{{ "FIAL_EXAMINATIONS" |
                    translate
                    | titlecase }}</h5>
                <app-loader [show]="showLoader"></app-loader>
                <br>
                <div id="accordion" *ngIf="showLoader==false">
                    <div class="card">
                        <div id="collapseOne">
                            <div class=" card-body">
                                <form [formGroup]="searchForm" (change)="searchFormChange()"
                                    (submit)="searchFormSubmit()">
                                    <div class="row">
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "ACADMIC_YEAR" | translate | titlecase
                                                }}</label>
                                            <select class="form-control custom-select" formControlName="year"
                                                (change)="getYearSemesters()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of years" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "SEMESTER" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="semester"
                                                (change)="getBatches()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of semesters" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.semesterNameAr :
                                                    field?.semesterNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.semester.touched && searchForm.controls.semester.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="batch"
                                                (change)="getBatchCourses()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <!-- <option value="202">{{ "static group" | translate | titlecase
                                                    }}
                                                </option> -->
                                                <option *ngFor="let field of batches" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.gradeNameAr : field?.gradeNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.batch.touched && searchForm.controls.batch.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1"
                                            style="padding-top: 23px !important;">
                                            <button type="submit" class="btn btn-primary">
                                                {{ "SEARCH" | translate | titlecase }}</button>
                                        </div>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold"> {{ "COURSE" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="course">
                                                <option value="" [selected]="true">{{ "SELECT" | translate |
                                                    titlecase
                                                    }}</option>
                                             <option value="770">{{ "static group" | translate |
                                                    titlecase
                                                    }}</option> 
                                                <option *ngFor="let field of courses" [value]="field.id">
                                                    {{(globals.lang == 'ar')? field.subjectNameAr :
                                                    field.subjectNameEn}} - ({{field.subjectCode}})</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.course.touched && searchForm.controls.course.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-6 form-group px-md-5 mb-1"
                                            style="padding-top: 23px !important;">
                                            <button type="submit" class="btn btn-primary">
                                                {{ "SEARCH" | translate | titlecase }}</button>
                                        </div>
                                    </div> -->
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <br>

                <div class="row" *ngIf="Searched">
                    <div class="col-md-4 form-group px-md-5 mb-1">
                        <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
                        <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                            routerLink="/exams/final-examinations/create"
                            [queryParams]="{yearId: currentYear, semesterId: currentSemester, batchId: currentBatch}"><i
                                class="fas fa-plus"></i> {{ "ADD" |
                            translate |
                            titlecase }}</button>
                    </div>
                </div>


                <br />
                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <table *ngIf="finalExamData.length >= 1&& Searched" class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <th>{{ "ID" | translate | titlecase }}</th>
                                <th>{{ "COURSE" | translate | titlecase }}</th>
                                <th>{{ "ASSESS_UNIT" | translate | titlecase }}</th>

                                <th>{{ "UPLOADED_FILENAME" | translate | titlecase }}</th>
                                <th>{{ "UPLOAD_DOWNLAOD" | translate | titlecase }}</th>

                                <th>{{ "STATUS" | translate | titlecase }}</th>

                                <th class="border-0 font-14 px-2 text-grey"></th>
                                <th class="border-0 font-14 px-2 text-grey"></th>
                                <th class="border-0 font-14 px-2 text-grey"></th>
                                <th class="border-0 font-14 px-2 text-grey"></th>
                                <!-- <th class="border-0 font-14 px-2 text-grey" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">{{ "COURSE_MODIFY" | translate | titlecase }}</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of finalExamData let i = index">
                                <td>{{res?.id}}</td>
                                <td>
                                    {{
                                    (globals.lang == 'ar')? res?.course?.subjectNameAr : res?.course?.subjectNameEn
                                    }}
                                </td>
                                <td>
                                    {{
                                    (globals.lang == 'ar')? res?.assUnit?.subjAsesNameAr : res?.assUnit?.subjAsesNameEn
                                    }}
                                </td>

                                <td>{{res?.filename}}</td>
                                <td class="text-bold">
                                    <a class="btn btn-sm btn-link text-warning" data-toggle="modal"
                                        data-target="#uploadExamScoresFile" href="#"
                                        (click)="updateCurrentExamId(res?.id)"
                                        title="{{ 'UPLOAD_FILE' | translate | titlecase }}"
                                        *ngIf="res?.asesStatus == 'DRAFT'"><i class="fas fa-file-upload"
                                            style="font-size: 25px;"></i></a> - <a class="btn btn-sm btn-link text-grey"
                                        href="{{downloadLink + res?.filename}}.csv"
                                        title="{{ 'DOWNLOAD' | translate | titlecase }}" target="_blank"
                                        *ngIf="res?.filename"><i class="fas fa-file-download"
                                            style="font-size: 25px;"></i></a>
                                </td>
                                <td>{{res?.asesStatus}}</td>

                                <td class="text-bold">
                                    <button type="button" class="btn btn-primary" (click)="updateExamStatus(res?.id, 1)"
                                        *ngIf="res?.asesStatus == 'DRAFT'">
                                        {{ "SUBMIT" | translate | titlecase }}</button>
                                </td>
                                <td class="text-bold">
                                    <button type="button" class="btn btn-info" data-toggle="modal"
                                        data-target="#scoresDetails" (click)="getExamScoreDetails(res?.id)"
                                        *ngIf="res?.filename">
                                        {{ "DETAILS" | translate | titlecase }}</button>
                                </td>
                                <td class="text-bold">
                                    <button type="button" class="btn btn-danger" data-toggle="modal"
                                        data-target="#deleteExam" (click)="updateIdSelected(res?.id)"
                                        *ngIf="res?.asesStatus == 'DRAFT'">
                                        {{ "DELETE" | translate | titlecase }}</button>
                                </td>
                                <td class="text-bold text-warning">
                                    <button type="button" class="btn btn-warning" data-toggle="modal"
                                        data-target="#cancelExam" (click)="updateIdSelected(res?.id)"
                                        *ngIf="res?.asesStatus == 'SUBMITTED'">
                                        {{ "CANCEL" | translate | titlecase }}</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal DisableServiceData-->
<div class="modal fade" id="scoresDetails" tabindex="-1" aria-labelledby="scoresDetails" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered student-detail-modal">
        <form class="modal-content col-md-12">
            <div class="row">
                <div class="col-sm-1">
                    <button (click)="exportDate()" class="btn" style="height:auto"><span
                            style="font-size: 2em; color: green;"><i
                                class="fas fa-file-excel fa-sm"></i></span></button>
                </div>
            </div>
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "SCORES_DETAILS" | translate | titlecase
                    }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="card-body">
                <!-- <div class="col-md-2.5 px-md-5 form-group" >
                    <button type="button" class="btn btn-primary" (click)="exportDate()">
                        <span style="font-size: 1.5em; color: white;"><i class="fas fa-file-excel fa-sm"></i></span> {{ "EXPORT" | translate | titlecase }}</button>
                </div> -->
                <!-- <div class="row">
                    <div class="col-sm-1">
                        <button (click)="exportDate()" class="btn" style="height:auto"><span
                                style="font-size: 2em; color: green;"><i
                                    class="fas fa-file-excel fa-sm"></i></span></button>
                    </div>
                </div> -->
                <app-loader [show]="loadScoreDetails"></app-loader>
                <table id="datetable" class="table table-bordered" *ngIf="scoreDetails.length > 0 && !loadScoreDetails">
                    <thead>
                        <tr>
                            <th>{{ "ID" | translate | titlecase }}</th>
                            <th>{{ "STUDENT_ID" | translate | titlecase }}</th>
                            <th>{{ "STUDENT_FULL_NAME" | translate | titlecase }}</th>
                            <th>{{ "INTIAL_SCORE" | translate | titlecase }}</th>
                            <th>{{ "REMARKS" | translate | titlecase }}</th>
                            <th>{{ "SCORE" | translate | titlecase }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let res of scoreDetails let i = index">
                            <td>{{res?.id}}</td>
                            <td>{{res?.student?.id}}</td>
                            <td>{{
                                (globals.lang == 'ar')? res?.student?.fullNameAr : res?.student?.fullNameEn
                                }}</td>
                            <td>{{res?.studentScoreOriginal}}</td>
                            <td><input type="text" class="form-control" [value]="res?.remarks" 
                                (focusout)="updateStudentRemark($event, res?.id)"/></td>
                            <td> <input type="number" class="form-control" [value]="res?.studentScore"
                                    (focusout)="updateStudentScore($event, res?.id)" /></td>
                            
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <!-- <button type="button" class="btn btn-primary" (click)="">Yes</button> -->
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ "CLOSE" | translate | titlecase
                    }}</button>
            </div>
        </form>
    </div>
</div>

<!-- Delete model -->
<div class="modal fade" id="deleteExam" tabindex="-1" aria-labelledby="deleteExamLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <i class="fas fa-trash text-danger"></i>
                </div>
                <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b></div>
                <a type="button" class="btn btn-link text-danger" data-dismiss="modal"
                    (click)="updateExamStatus(currentSelectedId, 2)">{{ "YES_DELETE_IT" | translate | titlecase }}</a>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>

<!-- Cancel Model -->
<div class="modal fade" id="cancelExam" tabindex="-1" aria-labelledby="cancelExamLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b></div>
                <a type="button" class="btn btn-link text-danger" data-dismiss="modal"
                    (click)="updateExamStatus(currentSelectedId, 3)">{{ "YES_CANCEL_IT" | translate | titlecase }}</a>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>

<!-- Modal UploadExamScoresFile-->
<div class="modal fade" id="uploadExamScoresFile" tabindex="-1" aria-labelledby="uploadExamScoresFile"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <form class="modal-content col-md-12" [formGroup]="uploadFileForm" (change)="uploadFileFormChange()"
            (submit)="uploadFileFormSubmit()" enctype="multipart/form-data">
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "UPLOAD_SCORES_FILE" | translate | titlecase
                    }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="card-body">
                <app-loader [show]="uploadingFile"></app-loader>
                <div class="col-md-12 form-group" *ngIf="!uploadingFile">
                    <label class="text-bold">{{ "FILE" | translate | titlecase }}</label>
                    <input type="file" class="form-control" formControlName="fileUpload" (change)="changeFile($event)"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                    <div class="alert alert-danger py-1 mt-1"
                        *ngIf="uploadFileForm.controls.fileUpload.touched && uploadFileForm.controls.fileUpload.invalid && uploadFileForm.dirty">
                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                    </div>
                </div>
            </div>
            <div class="modal-footer" *ngIf="!uploadingFile">
                <button type="submit" class="btn btn-primary">{{ "SAVE" | translate | titlecase
                    }}</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" #closeUploadFilePopup>{{ "CLOSE" |
                    translate | titlecase
                    }}</button>
            </div>
        </form>
    </div>
</div>